import React, { Component } from 'react';
import { connect } from 'dva';
import moment from 'moment';
import router from 'umi/router';
import {
  Button,
  Row,
  Col,
  Form,
  Input,
  Tooltip,
  Modal,
  message,
  Cascader,
  DatePicker,
  Select,
  Popconfirm,
} from 'antd';
import OperateDropdown from '../../../../components/OperateDropdown';
import ListPage from '../../../../components/ListPage';
import Container from '../../../../components/Container';
import TreeSelectChannel from '../ArticlePublished/components/TreeSelectChannel';
import { getAppCode } from '../utils/utils';
import { convertData, getDefaultData, getLabelStrData } from '../utils/convertData';
import { getPathHeader } from '../../../../utils/utils';
import styles from './index.less';

const { RangePicker } = DatePicker;

const { ListTable } = ListPage;
const { Option } = Select;
const defaultDate = moment().format('YYYY-MM-DD');
@Form.create()
@connect(({ user, matterManage }) => {
  return {
    orgId: user.currentUser.orgId,
    ...matterManage,
  };
})
class MatterManage extends Component {
  constructor(props) {
    super(props);
    this.state = {
      columns: [],
      dataSource: [],
      channelList: [],
      loading: false,
      totalElements: 0,
      visible: false,
      selectChannelId: [],
      selectRcord: {},
      alreadyPushList: {},
      params: {
        title: '',
        appCode: getAppCode(),
        page: 1,
        pageSize: 10,
        channelId: '',
        labelId: 0,
        startDay: '',
        endDay: '',
        newsTypes: '2',
      },
      channelId: '0',
      treeChannelData: [],
      labelList: [],
    };
  }

  componentDidMount() {
    const { params } = this.state;
    this.setColumns();
    this.fetchChannelList();
    this.fetchNewsManagerList(params);
    this.fetchLabelList();
  }

  // 获取标签列表
  fetchLabelList = () => {
    const { dispatch } = this.props;
    this.setState({ loading: true });
    dispatch({
      type: 'matterManage/fetchLabelList',
      params: { appCode: getAppCode() },
    })
      .then(res => {
        const arr = [];
        (res || []).forEach(item => {
          arr.push({ ...item, checked: false });
        });
        this.setState({ labelList: arr, loading: false });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  search = e => {
    e.preventDefault();
    const { form } = this.props;
    form.validateFieldsAndScroll((err, values) => {
      if (!err) {
        const { params, channelId } = this.state;
        const rangeValue = values['range-picker'];
        const tempParams = {
          ...params,
          title: values.title ? encodeURIComponent(values.title) : '',
          channelId,
          labelId: values.labelId,
          startDay: rangeValue && rangeValue[0] ? rangeValue[0].format('YYYY-MM-DD') : '',
          endDay: rangeValue && rangeValue[1] ? rangeValue[1].format('YYYY-MM-DD') : '',
          page: 1,
        };
        this.setState({
          params: tempParams,
        });
        this.fetchNewsManagerList(tempParams);
      }
    });
  };

  reSet = () => {
    const { form } = this.props;
    form.resetFields();
    const { params, channelId } = this.state;
    const tempParams = {
      ...params,
      title: '',
      labelId: 0,
      channelId,
      page: 1,
      startDay: defaultDate,
      endDay: defaultDate,
    };
    this.setState({
      params: tempParams,
    });
    this.fetchNewsManagerList(tempParams);
  };

  fetchNewsManagerList = params => {
    const { dispatch } = this.props;
    const { alreadyPushList } = this.state;
    this.setState({ loading: true });
    dispatch({
      type: 'matterManage/fetchNewsManagerList',
      params,
    })
      .then(res => {
        this.setState({
          loading: false,
          dataSource: getLabelStrData(res, alreadyPushList),
          totalElements: res.totalElements,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  fetchChannelList = () => {
    const { dispatch } = this.props;
    this.setState({ loading: true });
    dispatch({
      type: 'matterManage/fetchChannelList',
      params: { appCode: getAppCode() },
    })
      .then(res => {
        const data = [{ value: 0, label: '全部栏目', children: convertData(res || []) }];
        const channelList = convertData(res || []);
        channelList.unshift({ value: 0, label: '全部', children: [] });
        this.setState({
          channelList,
          treeChannelData: data,
          loading: false,
        });
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  fetchNewsRemove = record => {
    const { dispatch } = this.props;
    this.setState({ loading: true });
    dispatch({
      type: 'matterManage/fetchNewsRemove',
      params: { ids: record.id },
    })
      .then(() => {
        this.setState({ loading: false });
        message.success('撤下成功');
        const { params } = this.state;
        this.fetchNewsManagerList(params);
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  setColumns = () => {
    const columns = [
      {
        title: '标题',
        dataIndex: 'title',
        key: 'title',
        width: 400,
        fixed: 'left',
        render: text => {
          if (text.length <= 20) {
            return <span>{text}</span>;
          }
          return (
            <Tooltip placement="top" title={text}>
              <span>{text.substring(0, 20)}...</span>
            </Tooltip>
          );
        },
      },
      {
        title: '关联标签',
        dataIndex: 'labelList',
        key: 'labelList',
        width: 220,
        render: (text, record) => {
          const str = record.labelData && record.labelData.join(';');
          if (!str) {
            return <span>-</span>;
          }
          if (str.length <= 12) {
            return <span>{str}</span>;
          }
          return (
            <Tooltip placement="top" title={str}>
              <span>{str.substring(0, 12)}...</span>
            </Tooltip>
          );
        },
      },
      {
        title: '类型',
        dataIndex: 'newstype',
        key: 'newstype',
        width: 150,
        render: () => {
          return '视频素材';
        },
      },
      {
        title: '创建时间',
        dataIndex: 'createTime',
        key: 'createTime',
        render: text => {
          return <span>{moment(text).format('YYYY.MM.DD HH:mm')}</span>;
        },
      },

      {
        title: '操作',
        dataIndex: 'action',
        key: 'action',
        width: 160,
        fixed: 'right',
        render: (text, record) => {
          const data = [
            {
              text: (
                <a
                  onClick={e => {
                    e.stopPropagation();
                    router.push(
                      `/${getPathHeader()}/submissions/matter/create?id=${
                        record.id
                      }&appCode=${getAppCode()}&from=matter`
                    );
                  }}
                >
                  编辑
                </a>
              ),
            },

            {
              text: <a onClick={() => this.movement(record)}>移动</a>,
            },
            {
              text: (
                <Popconfirm
                  title="确认删除？"
                  okText="确认"
                  cancelText="取消"
                  onConfirm={() => this.fetchNewsRemove(record)}
                >
                  <a>删除</a>
                </Popconfirm>
              ),
            },
          ];
          const newData = [];
          data.forEach(item => {
            if (item.text) {
              newData.push(item);
            }
          });
          return <OperateDropdown data={newData} />;
        },
      },
    ];
    this.setState({ columns });
  };

  setChannelId = id => {
    const { params } = this.state;
    this.setState({ channelId: id, params: { ...params, page: 1 } });
  };

  changePage = (page, pageSize) => {
    const { params, channelId } = this.state;
    const tempParams = {
      ...params,
      page,
      pageSize,
      channelId: channelId === '0' ? '' : channelId,
    };
    this.setState({ params: tempParams });
    this.fetchNewsManagerList(tempParams);
  };

  movement = record => {
    if (!record.channel) {
      message.error('系统栏目的课程不能移动');
      return;
    }
    const { channelList } = this.state;
    this.setState(
      {
        selectChannelId: getDefaultData(channelList, record.channel.id),
        selectRcord: record,
      },
      () => {
        this.setState({ visible: true });
      }
    );
  };

  handleOk = () => {
    const { selectChannelId, selectRcord } = this.state;

    const { dispatch } = this.props;
    this.setState({ loading: true });
    dispatch({
      type: 'matterManage/fetchNewsMovement',
      params: {
        toChanneldId: selectChannelId[selectChannelId.length - 1],
        ids: selectRcord.id,
      },
    })
      .then(() => {
        this.setState({ loading: false, visible: false });
        const { params } = this.state;
        this.fetchNewsManagerList(params);
      })
      .catch(() => {
        this.setState({ loading: false });
      });
  };

  handleChange = value => {
    this.setState({ selectChannelId: value });
  };

  // 跳转详情
  handleGoToDetail = id => {
    router.push(`/${getPathHeader()}/matter/manage/detail?id=${id}&appCode=${getAppCode()}&type=matter`);
  };

  render() {
    const {
      columns,
      loading,
      dataSource,
      params,
      totalElements,
      channelList = [],
      visible,
      selectChannelId,
      treeChannelData,
      labelList,
    } = this.state;
    const { page } = params;
    const { form } = this.props;
    const { getFieldDecorator } = form;
    const formItemLayout = {
      labelCol: { span: 6 },
      wrapperCol: { span: 16 },
    };

    const pageProps = {
      spinProps: { spinning: loading },
      className: styles.root,
    };

    const tableProps = {
      pageInfo: { totalElements, page },
      columns,
      list: dataSource,
      rowKey: 'id',
      onItemClick: this.handleGoToDetail,
      onPageChange: this.changePage,
    };

    return (
      <Container breStates isSplitBar>
        <ListPage {...pageProps}>
          <Row className={styles['search-area']}>
            <Col span={8}>
              <Form.Item {...formItemLayout} label="素材名称">
                {getFieldDecorator('title', {
                  rules: [
                    {
                      max: 50,
                      message: '请勿超过50个字!',
                    },
                  ],
                })(<Input placeholder="请输入素材名称" onPressEnter={this.search} />)}
              </Form.Item>
            </Col>

            <Col span={8}>
              <Form.Item label="时间" {...formItemLayout}>
                {getFieldDecorator(
                  `range-picker`,
                  {}
                )(<RangePicker format="YYYY.MM.DD" placeholder={['请选择', '请选择']} />)}
              </Form.Item>
            </Col>
            <Col span={8}>
              <Form.Item {...formItemLayout} label="标签">
                {getFieldDecorator('labelId', {
                  initialValue: 0,
                })(
                  <Select>
                    <Option value={0}>全部</Option>
                    {labelList.map(item => {
                      return <Option value={item.id}>{item.label}</Option>;
                    })}
                  </Select>
                )}
              </Form.Item>
            </Col>
            <Col
              span={8}
              offset={16}
              style={{ textAlign: 'right', paddingRight: 24, marginTop: 10 }}
            >
              <Form.Item>
                <Button type="primary" onClick={this.search}>
                  查询
                </Button>
                <Button onClick={this.reSet}>重置</Button>
              </Form.Item>
            </Col>
          </Row>
          <section className="table-area">
            <div>
              <TreeSelectChannel
                channelList={treeChannelData}
                params={params}
                fetchPublishList={this.fetchNewsManagerList}
                setChannelId={this.setChannelId}
              />
            </div>
            <div>
              <ListTable {...tableProps} />
            </div>
          </section>
          <Modal
            title="移动到其他栏目"
            centered
            visible={visible}
            onOk={this.handleOk}
            onCancel={() => this.setState({ visible: false })}
          >
            <Cascader
              style={{ width: '100%' }}
              onChange={this.handleChange}
              options={channelList}
              defaultValue={selectChannelId}
              value={selectChannelId}
              placeholder="请选择发布的栏目"
            />
          </Modal>
        </ListPage>
      </Container>
    );
  }
}

export default MatterManage;
